/* eslint-disable import/prefer-default-export */
const scrollToElement = (options) => {
  const { element, offset, position, behavior } = options;
  let y = 0;
  if (element) {
    // console.log(`scrolling-utils.js, scrollToElement, ${element.offsetTop}`);
    y = element.offsetTop;
  }
  if (position) {
    y = position;
  }
  if (offset) {
    y += offset;
  }
  window.scrollTo({
    top: y,
    behavior,
  });
};

export {
  scrollToElement,
};
/* eslint-enable import/prefer-default-export */
